import type { ClientDetail } from '@jobos/shared/types/client';
import { formatClientName } from '@jobos/shared';

interface ClientInfoSectionProps {
  client: ClientDetail;
}

export function ClientInfoSection({ client }: ClientInfoSectionProps) {
  return (
    <div className="bg-white shadow rounded-lg mb-8">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Client Information
        </h2>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Client Name
            </label>
            <div className="text-sm text-gray-900">{formatClientName(client.name, client.firstName, client.lastName)}</div>
          </div>

          {client.managerName && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Manager Name
              </label>
              <div className="text-sm text-gray-900">
                {client.managerName}
              </div>
            </div>
          )}

          {client.contactInfo && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contact Information
              </label>
              <div className="text-sm text-gray-900">
                {client.contactInfo}
              </div>
            </div>
          )}


        </div>
      </div>
    </div>
  );
}
